import { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import BreadcrumbsIcon from "../../assets/breadcrumbs.svg";
import styles from "./breadcrumb.module.css";

interface BreadcrumbItem {
  label: any;
  path: string;
  browserBack?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  customStyles?: object;
}

export default function Breadcrumb({ items, customStyles }: BreadcrumbProps) {
  const history = useHistory();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setIsDropdownOpen((prev) => !prev);
    }
    if (e.key === "Escape") {
      setIsDropdownOpen(false);
    }
  };

  const navigate = (path: string) => {
    setIsDropdownOpen(false);
    history.push(path);
  };

  const updatedItems = [{ label: "ATOM", path: "/" }, ...items];

  return (
    <nav
      aria-label="breadcrumb"
      className={styles.outerNav}
      style={{ ...customStyles }}
    >
      <ul className={styles.breadcrumb}>
        <div
          className={styles.dropdownWrapper}
          ref={dropdownRef}
          onMouseEnter={() => setIsDropdownOpen(true)}
          onMouseLeave={() => setIsDropdownOpen(false)}
        >
          <button
            type="button"
            aria-haspopup="true"
            aria-expanded={isDropdownOpen}
            aria-label="Navigation menu"
            className={styles.dropdownTrigger}
            onClick={() => setIsDropdownOpen((prev) => !prev)}
            onKeyDown={handleKeyDown}
          >
            <img
              src={BreadcrumbsIcon}
              alt=""
              aria-hidden="true"
              className={styles.breadcrumbIcon}
            />
          </button>
          {isDropdownOpen && (
            <div className={styles.dropdownMenu} role="menu">
              <button
                type="button"
                role="menuitem"
                className={styles.dropdownItem}
                onClick={() => navigate("/entry-hub?console=Discover")}
                onKeyDown={(e: React.KeyboardEvent) => e.key === "Escape" && setIsDropdownOpen(false)}
              >
                Discover
              </button>
              <button
                type="button"
                role="menuitem"
                className={styles.dropdownItem}
                onClick={() => navigate("/entry-hub?console=Engage")}
                onKeyDown={(e: React.KeyboardEvent) => e.key === "Escape" && setIsDropdownOpen(false)}
              >
                Engage
              </button>
              <button
                type="button"
                role="menuitem"
                className={styles.dropdownItem}
                onClick={() => navigate("/entry-hub?console=Measure")}
                onKeyDown={(e: React.KeyboardEvent) => e.key === "Escape" && setIsDropdownOpen(false)}
              >
                Measure
              </button>
            </div>
          )}
        </div>

        {updatedItems.map((item, index) => (
          <li
            key={index}
            className={styles.breadcrumbItem}
          >
            {index < updatedItems.length - 1 ? (
              <Link
                to={item.browserBack ? "#" : item.path}
                className={styles.link}
                onClick={(e) => {
                  if (item.browserBack) {
                    e.preventDefault();
                    window.history.back();
                  }
                }}
              >
                {item.label}
              </Link>
            ) : (
              <span className={styles.current} aria-current="page">
                {item.label}
              </span>
            )}

            {index === 0 && updatedItems.length > 1 && (
              <span className={styles.separator} aria-hidden="true">&#124;</span>
            )}
            {index > 0 && index < updatedItems.length - 1 && (
              <span className={styles.separator} aria-hidden="true">›</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
